import { jsx as _jsx } from "react/jsx-runtime";
import * as Ant from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslate } from "@bluelibs/x-ui";
import { useMutation } from "@apollo/client";
import { AppFileUpload } from "@bundles/UIAppBundle/mutations/AppFileUpload";
import { useEffect, useState } from "react";
export const FileUpload = ({ fileList = [], onChange, }) => {
    const t = useTranslate();
    const [files, setFiles] = useState(fileList.map((f) => ({ fileName: f.name, uid: f._id, name: f.name })));
    const [uploadFileIds, setUploadFileIds] = useState(fileList.map((f) => ({ uid: f._id, _id: f._id })));
    const [loading, setLoading] = useState(false);
    const [uploadFile] = useMutation(AppFileUpload);
    const handleUpload = async (files) => {
        setFiles(files);
        setLoading(true);
        const uploadPromises = files.map(async (file) => {
            const uploadRes = await uploadFile({ variables: { upload: file } });
            setUploadFileIds((oldIds) => {
                var _a, _b;
                return [
                    ...oldIds,
                    {
                        _id: (_b = (_a = uploadRes.data) === null || _a === void 0 ? void 0 : _a.AppFileUpload) === null || _b === void 0 ? void 0 : _b._id,
                        uid: file.uid,
                    },
                ];
            });
        });
        await Promise.all(uploadPromises);
        setLoading(false);
    };
    const handleRemove = (file) => {
        const filesItemIndex = files.findIndex((f) => f.uid === file.uid);
        const idsItemIndex = uploadFileIds.findIndex((f) => f.uid === file.uid);
        setFiles(files.filter((_, index) => index !== filesItemIndex));
        setUploadFileIds(uploadFileIds.filter((_, index) => index !== idsItemIndex));
    };
    useEffect(() => {
        onChange(uploadFileIds.map((f) => f._id));
    }, [uploadFileIds]);
    return (_jsx(Ant.Upload, Object.assign({ multiple: true, fileList: files, beforeUpload: (file, files) => {
            if (files.length > 0 && files[files.length - 1] === file) {
                handleUpload(files);
            }
            return false;
        }, onRemove: handleRemove }, { children: _jsx(Ant.Button, Object.assign({ loading: loading, type: "dashed", icon: _jsx(UploadOutlined, {}, void 0) }, { children: t("management.transactions.fields.upload") }), void 0) }), void 0));
};
